import React from "react";

const ReasonCode = (props) => {
  const code = props.code ? props.code.toUpperCase() : "";

  const getMessage = (code) => {
    if (code === "POLICY_DENIED") {
      return (
        <div className="policy-denied">
          <div className="summary">
            Access to this website/service has been denied because it falls
            under a category deemed risky in accordance with the Trinity Health
            Acceptable Use Policy.
          </div>
        </div>
      );
    } else if (code === "GEOIP_DENIED") {
      return (
        <div className="geoip-denied">
          <div className="summary">
            Access to this site has been denied because it is hosted in a
            geographic location deemed risky in accordance with the Trinity
            Health Acceptable Use Policy.
          </div>
        </div>
      );
    } else if (code === "TCP_ERROR") {
      return (
        <div className="tcp-error">
          <div className="summary">
            The website is down or there may be other problems preventing your
            browser from making a connection. These errors are usually fixed by
            trying one or more of the following:
            <div style={{ textAlign: "left" }}>
              <ol>
                <li>
                  Check the spelling of the URL in the browser's address bar.
                </li>
                <li>
                  Check that you are using an "S" in "http" or "https" if/as
                  needed.
                </li>
                <li>
                  Contact the vendor and ask if they are experiencing any known
                  issues.
                </li>
                <li>
                  Check if the website/business exists using a Google search.
                </li>
                <li>Try accessing the site again at a later time.</li>
              </ol>
              <strong>
                * You may need to work with your local Service Desk for
                assistance *
              </strong>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="default-reason">
          <div className="summary">
            Access to this website/service has been denied by Trinity
            Information Services
          </div>
        </div>
      );
    }
  };

  return <div className="reason-code">{getMessage(code)}</div>;
};

export default ReasonCode;
